// pages/HomePage.js — the single homepage.
import React, { useRef } from 'react';
import SEO from '../components/SEO';
import Hero from '../components/Hero';
import DemoVideos from '../components/DemoVideos';
import VideoShowcase from '../components/VideoShowcase';
import StatsBand from '../components/StatsBand';
import Features from '../components/Features';
import Comparison from '../components/Comparison_Enhanced';
import TeamEmpowerment from '../components/TeamEmpowerment';
import Quote from '../components/Quote';
import Pricing from '../components/Pricing';
import UseCases from '../components/UseCases';
import HowItWorks from '../components/HowItWorks';
import LatestBlog from '../components/LatestBlog';
import CTA from '../components/CTA_Enhanced';
import {
  organizationSchema,
  webSiteSchema,
  softwareApplicationSchema,
  howToSchema,
} from '../data/structuredData';

const homeJsonLd = [
  organizationSchema,
  webSiteSchema,
  softwareApplicationSchema,
  howToSchema,
];

function HomePage() {
  // Refs preserved for sections that other code may scroll/observe.
  const comparisonRef = useRef(null);
  const quoteRef = useRef(null);
  const pricingRef = useRef(null);
  const useCasesRef = useRef(null);
  const howItWorksRef = useRef(null);
  const ctaRef = useRef(null);

  return (
    <>
      <SEO
        title="Qate AI - GenAI Quality Assurance | AI Testing for Web, Desktop & API"
        description="AI testing platform that clicks, types, and navigates your app like a real user. Conversational test creation, self-healing tests, automated bug fixing for web, Windows desktop & API."
        canonical="/"
        jsonLd={homeJsonLd}
      />

      {/* 1. Hero — claim + live agent demo */}
      <Hero />

      {/* 2. See it in action */}
      <DemoVideos />

      {/* 3. State Explorer video */}
      <VideoShowcase />

      {/* 4. Impact stats */}
      <StatsBand />

      {/* 5. Features */}
      <Features />

      {/* 6. Comparison */}
      <div ref={comparisonRef}>
        <Comparison />
      </div>

      {/* 7. Team empowerment */}
      <TeamEmpowerment />

      {/* 8. Testimonials */}
      <div ref={quoteRef}>
        <Quote />
      </div>

      {/* 9. Pricing */}
      <div ref={pricingRef}>
        <Pricing />
      </div>

      {/* 10. Use cases */}
      <div ref={useCasesRef}>
        <UseCases />
      </div>

      {/* 11. How it works */}
      <div ref={howItWorksRef}>
        <HowItWorks />
      </div>

      {/* 12. Latest blog posts */}
      <LatestBlog />

      {/* 13. Final CTA */}
      <div ref={ctaRef}>
        <CTA />
      </div>
    </>
  );
}

export default HomePage;
